import script from "./BaseSwitcher.vue?vue&type=script&lang=ts&setup=true"
export * from "./BaseSwitcher.vue?vue&type=script&lang=ts&setup=true"

import "./BaseSwitcher.vue?vue&type=style&index=0&id=3cfd0a70&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3cfd0a70"]])

export default __exports__